import type { StudentContractInfo, StudentContractLastSigned } from '@/types/api'

/**
 * MH13-04 — cache proprio do contrato assinado na area Privacidade (nao o
 * STUDENT_CONTRACT_KEY), para nao alimentar a faixa do layout.
 */
export const SIGNED_CONTRACT_KEY = ['contract', 'privacy'] as const

export function signedContract(info: StudentContractInfo | undefined): StudentContractLastSigned | null {
  if (!info) return null
  if (info.last_signed) return info.last_signed
  // API antiga, sem `last_signed`: so o payload do proprio assinado.
  if (!info.available || info.status !== 'signed') return null
  return {
    template_name: info.template_name,
    plan_name: info.plan_name,
    signed_at: info.signed_at,
    signed_file_url: info.signed_file_url ?? null,
  }
}
